import React from "react";
import { NavBar } from "../components/navigation/desktop/nav-bar";
import { MobileNavBar } from "../components/navigation/mobile/mobile-nav-bar";

export const PageCallback = () => {
    return (
        <div className="page-layout">
            <NavBar />
            <MobileNavBar />
            <div className="page-layout__content" />
        </div>
    );
};